/**
 * @deprecated Validation based on the target code should not be supported
 * anymore. Use the `UserAccessEntity` instead.
 */
export enum UserTargetCodeEntity {
	CIVILIAN = 'BUR',
	ECONOMIC_ACTOR = 'EA',
	LOCAL_GOVERNMENT = 'LB',
	FLEMISH_GOVERNMENT = 'GID'
}

/**
 * @deprecated Validation based on the target code should not be supported
 * anymore. Use the `UserAccessKeys` instead.
 */
export type UserTargetCodeEntityKeys = keyof typeof UserTargetCodeEntity;
